import { create } from "zustand";

interface AuthState {
  accessToken: string | null;
  email: string | null;
  isAdmin: boolean;
  setAuth: (token: string, email: string, isAdmin: boolean) => void;
  clearAuth: () => void;
  hydrate: () => void;
}

export const useAuthStore = create<AuthState>()((set) => ({
  accessToken: null,
  email: null,
  isAdmin: false,
  setAuth: (accessToken, email, isAdmin) => {
    localStorage.setItem("operio_token", accessToken);
    localStorage.setItem("operio_email", email);
    localStorage.setItem("operio_is_admin", isAdmin ? "1" : "0");
    set({ accessToken, email, isAdmin });
  },
  clearAuth: () => {
    localStorage.removeItem("operio_token");
    localStorage.removeItem("operio_email");
    localStorage.removeItem("operio_is_admin");
    set({ accessToken: null, email: null, isAdmin: false });
  },
  hydrate: () => {
    const token = localStorage.getItem("operio_token");
    let email = localStorage.getItem("operio_email");
    const isAdmin = localStorage.getItem("operio_is_admin") === "1";
    if (token && (!email || email === "undefined" || email === "null")) {
      try {
        const payloadPart = token.split(".")[1];
        if (payloadPart) {
          const payload = JSON.parse(
            atob(payloadPart.replace(/-/g, "+").replace(/_/g, "/")),
          ) as { email?: string };
          email = payload.email ?? null;
          if (email) localStorage.setItem("operio_email", email);
          else localStorage.removeItem("operio_email");
        }
      } catch {
        email = null;
        localStorage.removeItem("operio_email");
      }
    }
    if (token && email) {
      set({ accessToken: token, email, isAdmin });
    } else if (token) {
      set({ accessToken: token, email: null, isAdmin });
    }
  },
}));
